import { Button, FormBox } from "@/components/ui-kit"
import { ArrowLeftIcon, ArrowRightIcon } from "@/components/icons"

type ForgotPasswordStepProps = {
  email: string
  emailError: string | null
  submitError: string | null
  successMessage: string | null
  isLoading: boolean
  onEmailChange: (value: string) => void
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  onBack: () => void
  onGoHome: () => void
}

export function ForgotPasswordStep({
  email,
  emailError,
  submitError,
  successMessage,
  isLoading,
  onEmailChange,
  onSubmit,
  onBack,
  onGoHome,
}: ForgotPasswordStepProps) {
  if (successMessage) {
    return (
      <>
        <h1 className="mb-4 text-[48px] leading-[52px] font-bold text-primary">
          Письмо отправлено на почту
        </h1>
        <p className="mb-8 text-lg leading-6 text-primary">
          Откройте письмо и перейдите по ссылке для изменения пароля
        </p>
        <Button
          type="button"
          className="max-w-[541px]"
          onClick={onGoHome}
          endIcon={<ArrowRightIcon size={24} />}
        >
          Вернуться на сайт
        </Button>
      </>
    )
  }

  return (
    <>
      <Button
        variant="link"
        type="button"
        className="mb-4 w-fit px-0 py-0 text-base text-muted-foreground"
        onClick={onBack}
      >
        <span className="inline-flex items-center gap-2">
          <span aria-hidden>
            <ArrowLeftIcon size={18} />
          </span>
          <span className="leading-[1]">Вход</span>
        </span>
      </Button>

      <h1 className="mb-4 text-[48px] leading-[52px] font-bold text-primary">
        Восстановление пароля
      </h1>
      <p className="mb-8 text-lg leading-6 text-primary">
        Укажите почту, на которую зарегистрирован аккаунт.
        <br />
        Мы отправим туда письмо для восстановления
      </p>

      <form onSubmit={onSubmit} noValidate className="flex w-full max-w-[541px] flex-col gap-8">
        <FormBox
          id="forgot-email"
          label="Почта"
          type="email"
          defaultValue={email}
          onChange={(event) => onEmailChange(event.target.value)}
          autoComplete="email"
        />
        {emailError ? <p className="text-sm text-destructive">{emailError}</p> : null}
        {submitError ? <p className="text-sm text-destructive">{submitError}</p> : null}

        <Button type="submit" disabled={isLoading || !email} endIcon={<ArrowRightIcon size={24} />}>
          {isLoading ? "Отправляем..." : "Получить письмо"}
        </Button>
      </form>
    </>
  )
}
